import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DowloadApp = _resolveComponent("DowloadApp")!
  const _component_WeChat = _resolveComponent("WeChat")!
  const _component_CustomSlider = _resolveComponent("CustomSlider")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.selectedIndex==0)
      ? (_openBlock(), _createBlock(_component_DowloadApp, { key: 0 }))
      : (_openBlock(), _createBlock(_component_WeChat, { key: 1 })),
    _createVNode(_component_CustomSlider, {
      items: _ctx.items,
      onSwitchTab: _ctx.handleSwitchTab
    }, null, 8, ["items", "onSwitchTab"])
  ], 64))
}